import { ClipboardList, Search, Sparkles, LineChart } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: ClipboardList,
    title: "Initial Consultation",
    desc: "A focused conversation to understand your child, your concerns, and set expectations.",
  },
  {
    n: "02",
    icon: Search,
    title: "Comprehensive Assessment",
    desc: "Standardized evaluations across relevant domains — motor, speech, cognitive and behavioural.",
  },
  {
    n: "03",
    icon: Sparkles,
    title: "Customized Therapy Plan",
    desc: "A personalised roadmap with clear goals, session frequency, and home strategies.",
  },
  {
    n: "04",
    icon: LineChart,
    title: "Ongoing Progress Tracking",
    desc: "Regular reviews, transparent metrics, and periodic parent conferences to celebrate progress.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="scroll-mt-20 py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#0055FF]">
            How it Works
          </div>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#0A192F] tracking-tight">
            A clear, calm path — from first call to real progress.
          </h2>
        </div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                data-testid={`process-step-${s.n}`}
                className="relative bg-white border border-[#E2E8F0] rounded-xl p-6"
              >
                <div className="flex items-center justify-between">
                  <div className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-[#0A192F] text-white">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div className="font-heading text-2xl font-bold text-[#E2E8F0]">
                    {s.n}
                  </div>
                </div>
                <h3 className="mt-5 font-heading text-lg font-semibold text-[#0A192F]">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-[#475569] leading-relaxed">
                  {s.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
